import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { AnimatePresence, motion } from "motion/react";
import { ReactNode } from "react";

interface DialogListContainerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: ReactNode;
  isEmpty?: boolean;
}

interface AnimatedListItemProps {
  children: ReactNode;
  itemKey: string | number;
  index: number;
  delay?: number;
}

export function AnimatedListItem({
  children,
  itemKey,
  index,
  delay = 0.025,
}: AnimatedListItemProps) {
  return (
    <motion.div
      key={itemKey}
      initial={{ opacity: 0, y: 0 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{
        opacity: 0,
        y: 0,
        transition: { duration: 0, delay: 0 },
      }}
      transition={{ delay: index * delay }}
      className="border-b last:border-b-0"
    >
      {children}
    </motion.div>
  );
}

export function DialogListContainer({
  open,
  onOpenChange,
  title,
  children,
  isEmpty = false,
}: DialogListContainerProps) {
  if (isEmpty) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md md:max-w-2xl max-h-[80vh] p-0">
        <DialogHeader className="flex flex-row items-center justify-between space-y-0 pl-4 pb-2 pr-2 pt-4 border-b">
          <DialogTitle className="text-xl font-semibold flex items-center">
            {title}
          </DialogTitle>
        </DialogHeader>
        <div className="overflow-auto flex-1 max-h-[60vh]">
          <AnimatePresence>{children}</AnimatePresence>
        </div>
      </DialogContent>
    </Dialog>
  );
}
